import { forwardRef, InputHTMLAttributes } from 'react';
import { Icon, IconName } from '../icons';
import { Spinner } from '../spinner';
import { IconWrapper, Wrapper } from './styled';

interface IconInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon: IconName;
  loading?: boolean;
  disabled?: boolean;
}

export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(
  ({ icon, loading, ...props }, ref): JSX.Element => {
    return (
      <Wrapper disabled={props.disabled}>
        <IconWrapper>
          {loading !== true && <Icon name={icon} />}
          {loading === true && <Spinner />}
        </IconWrapper>
        <input {...props} ref={ref} />
      </Wrapper>
    );
  }
);
